import { useRef, useState } from 'react';
import { FaHashtag } from "react-icons/fa6";
import ChannelCard from './ChannelCard';
import { useTranslation } from '../hooks/useTranslation';
import Modal from './portals/Modal';
import TeamsRegistrationComponent from './TeamsRegistrationComponent';
import { ThreeDotsLoading } from '../components/primitives';
import { useDatabase } from '../contexts/DatabaseContext';

export default function WorkspaceChannelsTab({ post, workspaceId, workspace, url, teamsUrl, catchErrorParse }) {
    const t = useTranslation();
    const [newChannelName, setNewChannelName] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const { createWorkspaceActionEvent } = useDatabase();
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    function handleSubmit (e) {
        e.preventDefault();
        if (workspace.workspaceType === 0 || workspace.workspaceType === 2 || workspace.workspaceType === 3) {
            if (!newChannelName || newChannelName.length > 80) {
                setError(t('Invalid Name'));
                return;
            }
            setLoading(true);
            async function postChannel() {
                let name = newChannelName;
                if (!validChannelName(name, workspace.workspaceType)) {
                    name = name.toLowerCase()
                        .replace(/\s+/g, '-')
                        .replace(/[^a-z0-9-]/g, '');
                }
                const endpoint = workspace.workspaceType === 2 ? 'discord' : 
                               workspace.workspaceType === 3 ? 'mobile' : 'slack-app';
                const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/${endpoint}/add-channel`, {
                    workspace: workspaceId,
                    name: name,
                });
                if (error) {
                    window.dispatchEvent(new CustomEvent('masterError', {
                        detail: {
                            code: errorCode,
                            message: errorMessage ? errorMessage : error.message
                        }
                    }));
                    setLoading(false);
                } else {
                    setNewChannelName("");
                    setLoading(false);
                    await createWorkspaceActionEvent("add_channel", workspace?.workspaceType, workspaceId);
                }
            }
            postChannel();
        }
        else if (workspace.workspaceType === 1) {
            console.log("WorkspaceId", workspaceId);
            setIsCreateModalOpen(true);
        }
    }

    function handleCloseModal() {
        setIsCreateModalOpen(false);
    }
    
    function validChannelName(name, workspaceType) {
        if (!name || name.length > 80) {
            return false;
        }
        if (workspaceType === 2) {
            // Discord channel name validation
            // Discord allows 1-100 characters but will mirror
            return /^[a-zA-Z0-9_-]+$/.test(name);
        } else if (workspaceType === 0) {
            // Slack channel name validation
            // Slack allows up to 80 characters
            return /^[a-z0-9_-]+$/.test(name) && !name.startsWith('_');
        }
        else if (workspaceType === 3) {
            return true;
        }
        return false;
    }

    function handleNewChannelNameChange(name) {
        setNewChannelName(name);
        if (!name || validChannelName(name, workspace.workspaceType)) {
            setError(null);
        } else {
            setError(name.length > 80 ? t('Too many characters') : t('Invalid characters will be replaced or removed'));
        }
    }

    async function handleChannelDelete(channelId) {
        console.log(channelId);
        if (workspace.workspaceType === 0 || workspace.workspaceType === 2 || workspace.workspaceType === 3) {
            const endpoint = workspace.workspaceType === 2 ? 'discord' : 
                           workspace.workspaceType === 3 ? 'mobile' : 'slack-app';
            const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/${endpoint}/delete-channel`, {
                workspace: workspaceId,
                channel: channelId,
            });
            if (error) {
                window.dispatchEvent(new CustomEvent('masterError', {
                    detail: {
                        code: errorCode,
                        message: errorMessage
                    }
                }));
                return;
            }
        }
        else if (workspace.workspaceType === 1) {
            const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${teamsUrl}/api/deauthorizechannel`, {
                ConversationId: channelId,
                WorkspaceId: workspaceId,
            });
            if (error) {
                window.dispatchEvent(new CustomEvent('masterError', {
                    detail: {
                        code: errorCode,
                        message: errorMessage
                    }
                }));
                return;
            }
        }
        await createWorkspaceActionEvent("delete_channel", workspace?.workspaceType, workspaceId);
    }

    const channels = Object.keys(workspace.channels);
    return (
        <div className="channel-card-list">
            {    
                workspace.channels &&
                channels.map((channelId, channelIndex) =>
                    <ChannelCard key={channelId} 
                        channel={workspace.channels[channelId]} 
                        workspaceId={workspaceId} 
                        channelId={channelId} 
                        channelIndex={channelIndex} 
                        workspaceType={workspace.workspaceType}
                        handleChannelDelete={handleChannelDelete}
                    />
                )
            }

            {channels.length < 9 && <form className={`channel-card${workspace.workspaceType === 1 ? ' teams' : ''}`} onSubmit={handleSubmit}>
                {workspace.workspaceType !== 1 && (
                    <input id="newChannelName" 
                    className={`channel-card-name-input ${error ? 'error' : ''}`} 
                    type="text" 
                    value={newChannelName}
                    onChange={(e) => handleNewChannelNameChange(e.target.value)}
                    required 
                    placeholder="Type channel name" 
                />)}
                {error && <label className="channel-card-name-input-error" htmlFor="newChannelName">{error}</label>}
                <button disabled={loading} className="channel-card-button w-100 mt-3" type="submit">
                    {loading ? <ThreeDotsLoading /> : t('Add Channel')}
                </button>
                <Modal open={isCreateModalOpen}>
                    <TeamsRegistrationComponent isPopup={true} workspaceId={workspaceId} closePopup={handleCloseModal} />
                </Modal>
            </form>}
        </div>
    );
}
